const NO_CACHE_PARAM = 'crsc_no_cache';
const NO_CACHE_STORAGE_KEY = 'crsc_no_cache';

/**
 * Persists the given no-cache value to session storage so it can be reused
 * on subsequent page loads.
 */
export const saveNoCacheValue = (noCacheValue: string) => {
    if (noCacheValue) {
        sessionStorage.setItem(NO_CACHE_STORAGE_KEY, noCacheValue);
    }
};

/**
 * Reads the `crsc_no_cache` query parameter from the current URL, if present,
 * and persists it to session storage so it can be reused on subsequent page loads.
 */
const persistNoCacheParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const noCacheValue = urlParams.get(NO_CACHE_PARAM);

    if (noCacheValue) {
        saveNoCacheValue(noCacheValue);
    }
};

/**
 * Appends the stored no-cache value to every link pointing to a /product/ or /class/ page,
 * preventing these dynamic pages from being served from server cache.
 */
const appendNoCacheToDynamicLinks = () => {
    const noCacheValue = sessionStorage.getItem(NO_CACHE_STORAGE_KEY);

    if (!noCacheValue) {
        return;
    }

    const dynamicLinks = document.querySelectorAll<HTMLAnchorElement>('a[href*="/product/"], a[href*="/class/"], a[href*="/class"]');

    dynamicLinks.forEach((link) => {
        try {
            const url = new URL(link.href, window.location.origin);
            if (url.pathname.includes('/product') || url.pathname.includes('/class')) {
                url.searchParams.set(NO_CACHE_PARAM, noCacheValue);
                link.href = url.toString();
            }
        } catch (error) {
            // Ignore links with an invalid href.
        }
    });
};

/**
 * Initializes the no-cache handling for dynamic pages: persists the
 * `crsc_no_cache` value to session storage and appends it to every /product/
 * and /class link on the page so requests bypass server caching.
 */
export const initNoCacheLinks = () => {
    persistNoCacheParam();
    appendNoCacheToDynamicLinks();
};
